import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateBranchForm from "../../forms/CreateOrUpdateBranchForm";
import { BranchResponseDto } from "../../shared/dtos/branch/BranchResponseDto";

interface UpdateBranchModalProps {
  open: boolean;
  onClose: () => void;
  branch: BranchResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateBranchModal: React.FC<UpdateBranchModalProps> = ({
  open,
  onClose,
  branch,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Branch: ${branch.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateBranchForm
      isEditing={true}
      branch={branch}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateBranchModal;
